import { LoadState } from "../../constants/enums";
import { getUniqueId } from "../../helpers";

export interface IAutomobileScheduleState {
  scheduleA: {
    loading: LoadState;
    data: IAutomobileScheduleA;
    listData: IAutomobileScheduleA[];
    listLoading: LoadState;
  };
}

export interface IAutomobileScheduleA {
  incremental_number: number | null;
  customer_policy_id: number | null;
  vehicle_number: number | null;
  coverage_number: number | null;
  coverage_name: string | null;
  coverage_details: IAutomobileScheduleCoverage[];
  // endorsements: ICommScheduleAColumns[];
  set_as_default: string | null;
  status: string;
  created_from: string | null;
  minimum_retained_premium: number | null;
  total_premium: number | null;
  vin: string | null;
  remarks: string | null;
}

export interface IAutomobileScheduleCoverage {
  key: string;
  code: string;
  deductible: string | null;
  description: string | null;
  label: string;
  isTypeOther: boolean;
  isOnlyPremimum: boolean;
  limit: string | null;
  premimum: string | null;
  isDeductible: boolean;
}

export const coverageData: IAutomobileScheduleCoverage[] = [
  {
    key: getUniqueId(),
    code: "TPBI",

    label: "Bodily Injury",
    deductible: "",
    description: "",
    limit: "",
    premimum: "",
    isTypeOther: false,
    isOnlyPremimum: false,
    isDeductible: false,
  },
  {
    key: getUniqueId(),
    code: "TPPD",

    label: "Property Damage",
    deductible: "",
    description: "",
    limit: "",
    premimum: "",
    isTypeOther: false,
    isOnlyPremimum: false,
    isDeductible: false,
  },
  {
    key: getUniqueId(),
    code: "AB",

    label: "Accident Benefits (Standard Benefits)",
    deductible: "",
    description: "",
    limit: "",
    premimum: "",
    isTypeOther: false,
    isOnlyPremimum: false,
    isDeductible: false,
  },

  {
    key: getUniqueId(),
    code: "MRB",

    label: "Increased Medical, Rehabilitation & Attendant Care – $130,000",
    deductible: "",
    description: "",
    limit: "",
    premimum: "",
    isTypeOther: false,
    isOnlyPremimum: false,
    isDeductible: false,
  },
  {
    key: getUniqueId(),
    code: "CIMRB",

    label: "Increased Medical, Rehabilitation & Attendant Care – $1,000,000",
    deductible: "",
    description: "",
    limit: "",
    premimum: "",
    isTypeOther: false,
    isOnlyPremimum: false,
    isDeductible: false,
  },
  {
    key: getUniqueId(),
    code: "CATIM",

    label: "Additional Catastrophic Impairment",
    deductible: "",
    description: "",
    limit: "",
    premimum: "",
    isTypeOther: false,
    isOnlyPremimum: true,
    isDeductible: false,
  },
  {
    key: getUniqueId(),
    code: "WIB",

    label: "Income Replacement",
    deductible: "",
    description: "",
    limit: "",
    premimum: "",
    isTypeOther: false,
    isOnlyPremimum: false,
    isDeductible: false,
  },
  {
    key: getUniqueId(),
    code: "NEB",

    label: "Non-Earner",
    deductible: "",
    description: "",
    limit: "",
    premimum: "",
    isTypeOther: false,
    isOnlyPremimum: true,
    isDeductible: false,
  },
  {
    key: getUniqueId(),
    code: "CGB",
    label: "Caregiver – Impairment",
    deductible: "",
    description: "",
    limit: "",
    premimum: "",
    isTypeOther: false,
    isOnlyPremimum: true,
    isDeductible: false,
  },
  {
    key: getUniqueId(),
    code: "CGCAT",
    label: "Caregiver – Catastrophic Only",
    deductible: "",
    description: "",
    limit: "",
    premimum: "",
    isTypeOther: false,
    isOnlyPremimum: true,
    isDeductible: false,
  },
  {
    key: getUniqueId(),
    code: "LEE",
    label: "Lost Educational Expenses",
    deductible: "",
    description: "",
    limit: "",
    premimum: "",
    isTypeOther: false,
    isOnlyPremimum: true,
    isDeductible: false,
  },
  {
    key: getUniqueId(),
    code: "EXV",
    label: "Expenses of Visitors",
    deductible: "",
    description: "",
    limit: "",
    premimum: "",
    isTypeOther: false,
    isOnlyPremimum: true,
    isDeductible: false,
  },
  {
    key: getUniqueId(),
    code: "HHM",
    label: "Housekeeping & Home Maintenance – Impairment",
    deductible: "",
    description: "",
    limit: "",
    premimum: "",
    isTypeOther: false,
    isOnlyPremimum: true,
    isDeductible: false,
  },
  {
    key: getUniqueId(),
    code: "HHCAT",
    label: "Housekeeping & Home Maintenance – Catastrophic Only",
    deductible: "",
    description: "",
    limit: "",
    premimum: "",
    isTypeOther: false,
    isOnlyPremimum: true,
    isDeductible: false,
  },
  {
    key: getUniqueId(),
    code: "DPI",
    label: "Damage to Personal Items",
    deductible: "",
    description: "",
    limit: "",
    premimum: "",
    isTypeOther: false,
    isOnlyPremimum: true,
    isDeductible: false,
  },
  {
    key: getUniqueId(),
    code: "DEA",

    label: "Death Benefit",
    deductible: "",
    description: "",
    limit: "",
    premimum: "",
    isTypeOther: false,
    isOnlyPremimum: true,
    isDeductible: false,
  },
  {
    key: getUniqueId(),
    code: "FNB",

    label: "Funeral Benefit",
    deductible: "",
    description: "",
    limit: "",
    premimum: "",
    isTypeOther: false,
    isOnlyPremimum: true,
    isDeductible: false,
  },
  {
    key: getUniqueId(),
    code: "DCB",

    label: "Dependant Care",
    deductible: "",
    description: "",
    limit: "",
    premimum: "",
    isTypeOther: false,
    isOnlyPremimum: true,
    isDeductible: false,
  },
  {
    key: getUniqueId(),
    code: "IDB",

    label: "Indexation Benefit",
    deductible: "",
    description: "",
    limit: "",
    premimum: "",
    isTypeOther: false,
    isOnlyPremimum: true,
    isDeductible: false,
  },
  {
    key: getUniqueId(),
    code: "UA",

    label: "Uninsured Automobile",
    deductible: "",
    description: "",
    limit: "",
    premimum: "",
    isTypeOther: false,
    isOnlyPremimum: true,
    isDeductible: false,
  },
  {
    key: getUniqueId(),
    code: "TPDC",

    label: "Direct Compensation-Property Damage",
    deductible: "",
    description: "",
    limit: "",
    premimum: "",
    isTypeOther: false,
    isOnlyPremimum: false,
    isDeductible: true,
  },
  {
    key: getUniqueId(),
    code: "SP",

    label: "Specified Perils (excluding Collision or Upset)",
    deductible: "",
    description: "",
    limit: "",
    premimum: "",
    isTypeOther: false,
    isOnlyPremimum: false,
    isDeductible: true,
  },
  {
    key: getUniqueId(),
    code: "CMP",

    label: "Comprehensive (excluding Collision or Upset)",
    deductible: "",
    description: "",
    limit: "",
    premimum: "",
    isTypeOther: false,
    isOnlyPremimum: false,
    isDeductible: true,
  },
  {
    key: getUniqueId(),
    code: "COL",

    label: "Collision or Upset",
    deductible: "",
    description: "",
    limit: "",
    premimum: "",
    isTypeOther: false,
    isOnlyPremimum: false,
    isDeductible: true,
  },
  {
    key: getUniqueId(),
    code: "AP",

    label: "All Perils",
    deductible: "",
    description: "",
    limit: "",
    premimum: "",
    isTypeOther: false,
    isOnlyPremimum: false,
    isDeductible: true,
  },
  {
    key: getUniqueId(),
    code: "44R",

    label: "Family Protection Coverage - OPCF 44R",
    deductible: "",
    description: "",
    limit: "",
    premimum: "",
    isTypeOther: false,
    isOnlyPremimum: false,
    isDeductible: false,
  },
  {
    key: getUniqueId(),
    code: "",
    label: "",
    deductible: "",
    description: "",
    limit: "",
    premimum: "",
    isTypeOther: true,
    isOnlyPremimum: false,
    isDeductible: false,
  },

  {
    key: getUniqueId(),
    code: "",
    label: "",
    deductible: "",
    description: "",
    limit: "",
    premimum: "",
    isTypeOther: true,
    isOnlyPremimum: false,
    isDeductible: false,
  },
  {
    key: getUniqueId(),
    code: "",
    label: "",
    deductible: "",
    description: "",
    limit: "",
    premimum: "",
    isTypeOther: true,
    isOnlyPremimum: false,
    isDeductible: false,
  },

  {
    key: getUniqueId(),
    code: "",
    label: "",
    deductible: "",
    description: "",
    limit: "",
    premimum: "",
    isTypeOther: true,
    isOnlyPremimum: false,
    isDeductible: false,
  },
  {
    key: getUniqueId(),
    code: "",
    label: "",
    deductible: "",
    description: "",
    limit: "",
    premimum: "",
    isTypeOther: true,
    isOnlyPremimum: false,
    isDeductible: false,
  },

  {
    key: getUniqueId(),
    code: "",
    label: "",
    deductible: "",
    description: "",
    limit: "",
    premimum: "",
    isTypeOther: true,
    isOnlyPremimum: false,
    isDeductible: false,
  },
  {
    key: getUniqueId(),
    code: "",
    label: "",
    deductible: "",
    description: "",
    limit: "",
    premimum: "",
    isTypeOther: true,
    isOnlyPremimum: false,
    isDeductible: false,
  },
];

export const INITIAL_COVERAGE_STATE: IAutomobileScheduleA = {
  incremental_number: null,
  customer_policy_id: 0,
  vehicle_number: null,
  coverage_number: null,
  coverage_name: null,
  coverage_details: coverageData,
  set_as_default: "N",
  minimum_retained_premium: null,
  total_premium: null,
  created_from: null,
  vin: null,
  status: "ACTIVE",
  remarks: null,
};

export const initialAutomoblieSchedule: IAutomobileScheduleState = {
  scheduleA: {
    data: INITIAL_COVERAGE_STATE,
    loading: LoadState.NotLoaded,
    listData: [],
    listLoading: LoadState.NotLoaded,
  },
};
